export default {
  getFeatures: (state) => state.features,
  getFeaturesIsError: (state) => state.status.isError,
  getFeaturesError: (state) => state.status.error,
  getFeaturesIsLoading: (state) => state.status.isLoading
};
